const History = {
    IDProductCB: 7, // Chat Bet
};

export default History;
